module.exports = __webpack_public_path__ + "img/logo2.3003f1bc.png";